import { AuthAccountEnvironmentMetaData } from '../../../../containers/pipeline/interfaces/source-type';
import { AuthAccountEnvironment } from './interface';

export const DEFAULT_AUTH_ACCOUNT_ENVIRONMENTS_METADATA: { [key: string]: AuthAccountEnvironmentMetaData } = {
  [AuthAccountEnvironment.PRODUCTION]: {
    label: 'Production',
    description: 'The environment where real data is stored'
  },
  [AuthAccountEnvironment.TESTING]: {
    label: 'Testing',
    description: 'An isolated environment for development and testing'
  }
};

export const DEFAULT_AUTH_ACCOUNT_ENVIRONMENT = AuthAccountEnvironment.PRODUCTION;

export const TRACKER_SELECT_OAUTH_ACCOUNT_ENVIRONMENT = '[Select OAuth Account] setup environment';
